const RELOAD_FLAG = "aw-chunk-reload";

/** Detect stale lazy-route chunks after a deploy (or CDN serving HTML for a missing asset). */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : error && typeof error === "object" && "message" in error
          ? String((error as { message: unknown }).message)
          : "";

  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("Unable to preload CSS") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("AIChat export not found") ||
    (message.includes("AIChat") &&
      (message.includes("is not an object") ||
        message.includes("is undefined") ||
        message.includes("Cannot read properties of undefined")))
  );
}

/**
 * Reload once when a hashed chunk is missing so users pick up the latest deploy.
 * Uses sessionStorage to avoid infinite reload loops.
 */
export function reloadOnceOnChunkError(error: unknown): void {
  if (!isChunkLoadError(error)) return;
  if (sessionStorage.getItem(RELOAD_FLAG)) return;

  sessionStorage.setItem(RELOAD_FLAG, "1");
  window.location.reload();
}

/** Clear the reload guard after a successful boot. */
export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_FLAG);
}

/** Wire global handlers for Vite preload failures and post-deploy chunk mismatches. */
export function installChunkReloadHandlers(): void {
  clearChunkReloadFlag();

  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    reloadOnceOnChunkError(event.payload);
  });
}
